import React, {Component} from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import MegaMenuItemThirdLevel from './MegeMenuItemThirdLevel'
import MegaMenuImageBlock from './MegeMenuImageBlock'

export default class MegaMenuItemSecondLevel extends Component {
  static propTypes = {
    title: PropTypes.string,
    url: PropTypes.string.isRequired,
    hasChildren: PropTypes.bool,
    isExpanded: PropTypes.bool,
    isCollapsed: PropTypes.bool,
    inActiveTrail: PropTypes.bool,
    subtree:  PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object,
    ]),
    obfuscate: PropTypes.bool,
    disableForLanguage: PropTypes.bool,
    class: PropTypes.string,
    classStyle: PropTypes.string,
    preselected: PropTypes.bool.isRequired,
    imagesBlock:  PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object,
    ]),
  }

  static defaultProps = {
    title: '',
    url: '',
    hasChildren: false,
    isExpanded: false,
    isCollapsed: false,
    inActiveTrail: false,
    subtree: null,
    obfuscate: false,
    disableForLanguage: false,
    class: '',
    classStyle: ''
  }

  constructor(props) {
    super(props)
    this.thirdLevelRef = React.createRef()
    this.handleClickOutside = this.handleClickOutside.bind(this)
  }

  componentDidMount() {
    const {
      preselected,
      subtree,
    } = this.props

    const hasChildren = Object.keys(subtree).length > 0

    document.addEventListener('mousedown', this.handleClickOutside)


    // wrap items of second level to apply styling
    function wrapAll(ary, wrapper) {
      if (ary && ary.length) {
        for (let i = 0; i < ary.length; i++) {
          wrapper.appendChild(ary[i])
        }
      }
    }

    const secondLevelNodes = document.querySelectorAll('.megamenu__item_second-level')
    const wrapper = document.querySelector('.megamenu__second-level-items-list')
    wrapAll(secondLevelNodes, wrapper)

    if (preselected && hasChildren) {
      this.setState({thirdLevelIsOpen: true})
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  handleClickOutside = (event) => {
    if (this.thirdLevelRef.current && !this.thirdLevelRef.current.contains(event.target)) {
      // Clicked outside the menu, so close it
      this.closeMenuThirdLevel()
    }
  }

  toggleMenuThirdLevel = (event) => {
    const {
      onclick,
      id,
      updateChildState,
    } = this.props
    // const {thirdLevelIsOpen} = this.state
    // Keypresses other than Enter and Space should not trigger a command
    if (event) {
        if (
            event.type === "keydown" &&
            event.key !== "Enter" &&
            event.key !== " "
        ) {
            return;
        }
    }

    updateChildState(id, true)
    // this.setState({thirdLevelIsOpen: !thirdLevelIsOpen})
  }

  closeMenuThirdLevel = () => {
    this.setState({thirdLevelIsOpen: false})
  }

  renderLink = () => {
    const {
      title,
      url,
      subtree,
      obfuscate,
      obfuscateDataUrl,
      attributes,
      thirdLevelIsOpen
    } = this.props

    let classFromBO = ''
    let targetFromBO = ''

    if (typeof attributes === 'object') {
      classFromBO = attributes.class
      targetFromBO = attributes.target
    }

    const hasChildren = Object.keys(subtree).length > 0

    if (obfuscate && !hasChildren) {
      // obfuscated link
      return (
        <span
          aria-label={title}
          role={'button'}
          tabIndex="0"
          className={cn('obfuscate', classFromBO)}
          data-link={obfuscateDataUrl}
          data-target={targetFromBO}
        >
          {title}
        </span>
      )
    } else if (hasChildren) {
      // Second level trigger
      return (
        <span
          aria-label={title}
          role={'button'}
          tabIndex="0"
          className={cn('hasChildren', thirdLevelIsOpen ? 'active' : '')}
          onClick={this.toggleMenuThirdLevel}
          onKeyDown={this.toggleMenuThirdLevel}
        >
          {title}
        </span>
      )
    } else {
      // default link
      return (
        <a
          aria-label={title}
          tabIndex="0"
          href={url}
          className={cn(classFromBO)}
          target={targetFromBO}
        >
          {title}
        </a>
      )
    }
  }

  render() {
    const {
      classStyle,
      subtree,
      disableForLanguage,
      imagesBlock,
      thirdLevelIsOpen,
    } = this.props

    // Split third level into three columns with min qty per column - 6
    const items = Object.keys(subtree).map((key, index) => (
      <MegaMenuItemThirdLevel key={key} {...subtree[key]} />
    ))

    const columnCount = 3
    const minItemsPerColumn = 6
    const itemsPerColumn = Math.max(minItemsPerColumn, Math.ceil(items.length / columnCount))
    const columns = []
    const hadThreeCols = items.length > minItemsPerColumn * 2
    for (let i = 0; i < columnCount; i++) {
      const startIndex = i * itemsPerColumn
      const endIndex = Math.min((i + 1) * itemsPerColumn, items.length)
      const columnItems = items.slice(startIndex, endIndex)
      if (columnItems.length > 0) {
        columns.push(
          <div className="megamenu__third-level-col" key={i}>
            {columnItems}
          </div>
        )
      }
    }

    return (
      <React.Fragment>
        {!disableForLanguage &&
        <div
          ref={this.thirdLevelRef}
          className={cn('megamenu__third-level-container', thirdLevelIsOpen ? 'active' : '')}>

            <div className={cn('megamenu__item megamenu__item_second-level', classStyle)} >
              {this.renderLink()}
            </div>

          {thirdLevelIsOpen &&
            <div className="megamenu__third-level">
              {columns}
            </div>
          }

          {thirdLevelIsOpen &&
            <div className={cn('megamenu__second-level-image-block')}>
              {/*
                In case parent second level item was setted to move to third level it will not containe imageBlock so
                we take image block of first third-level item
              */}

              {imagesBlock ? (
                <React.Fragment>
                  {imagesBlock && imagesBlock.images && imagesBlock.images[0] &&  (
                    <MegaMenuImageBlock {...imagesBlock.images[0]} key={imagesBlock.images[0].url}/>
                    )
                  }
                </React.Fragment>
              ) : (
                <React.Fragment>
                  {Object.values(subtree)[0].imagesBlock && Object.values(subtree)[0].imagesBlock.images && Object.values(subtree)[0].imagesBlock.images[0] &&
                    <MegaMenuImageBlock {...Object.values(subtree)[0].imagesBlock.images[0]} key={Object.values(subtree)[0].imagesBlock.images[0].url}/>
                  }
                </React.Fragment>
              )}
            </div>
          }
        </div>
        }
      </React.Fragment>
    )
  }
}
